export class TidalLocalModel {

    /**
     * Exchange shares
     */
    exchange_shares: bigint = BigInt(0);

    /**
     * Expire timestamp
     */
    expire_timestamp: bigint = BigInt(0);

    /**
     * Fill values
     * 
     * @param values 
     */
    fill(values: Array<any>) {
        this.exchange_shares = this.format(values, 'exchange_shares');
        this.expire_timestamp = this.format(values, 'expire_timestamp');
    }

    /**
     * Format value
     * 
     * @param values
     * @param key
     */
    private format(values: Array<any>, key: string): bigint {
        let value = values.find(x => x.key == 'tidal_' + key);
        if (value) {
            return BigInt(value.value);
        } else {
            return BigInt(0);
        }
    }
}